import { render, staticRenderFns } from "./ImageShadowProperties.vue?vue&type=template&id=c1ef1004"
import script from "./ImageShadowProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageShadowProperties.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports